const LOCAL_MEDIATORS_URL = "http://localhost:5173";
const PRODUCTION_MEDIATORS_URL = "https://mediators.kz";

const MEDIATORS_URL_BY_ENV = {
  t1: "https://t1.mediators.kz",
  t2: "https://t2.mediators.kz",
} as const;

export function getMediatorsUrl(hostname = window.location.hostname) {
  if (hostname === "localhost") {
    return LOCAL_MEDIATORS_URL;
  }

  if (hostname.startsWith("t1.")) {
    return MEDIATORS_URL_BY_ENV.t1;
  }

  if (hostname.startsWith("t2.")) {
    return MEDIATORS_URL_BY_ENV.t2;
  }

  return PRODUCTION_MEDIATORS_URL;
}

export const MEDIATORS_URL =
  typeof window === "undefined"
    ? PRODUCTION_MEDIATORS_URL
    : getMediatorsUrl(window.location.hostname);
